import { useAuth } from "react-oidc-context";
import LeadChatWidget from "./LeadChatWidget";
import AdminPage from "./pages/AdminPage";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import { useEffect, useState } from "react"; 
import { checkSubscription } from "./utils/checkSubscription"; 
import './App.css';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    padding: '40px 20px',
    fontFamily: "'Segoe UI', 'Roboto', sans-serif"
  },
  card: {
    maxWidth: '800px',
    margin: '0 auto',
    background: 'white',
    borderRadius: '15px',
    padding: '30px',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
  },
  title: {
    color: '#2c3e50',
    fontSize: '2.5rem',
    marginBottom: '20px',
    fontWeight: '600'
  },
  subtitle: {
    color: '#666',
    fontSize: '1.1rem',
    marginBottom: '30px'
  },
  button: {
    padding: '12px 24px',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    margin: '10px',
  },
  primaryButton: {
    backgroundColor: '#4CAF50',
    color: 'white',
    '&:hover': {
      backgroundColor: '#45a049'
    }
  },
  secondaryButton: {
    backgroundColor: '#2196F3',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1976D2'
    }
  },
  dangerButton: {
    backgroundColor: '#f44336',
    color: 'white',
    '&:hover': {
      backgroundColor: '#d32f2f'
    }
  },
  userInfo: {
    padding: '15px',
    background: '#f8f9fa',
    borderRadius: '8px',
    marginBottom: '20px'
  }
};

const features = [
  {
    title: "AI-Powered Chat",
    icon: "/assets/ai-icon.png",
    description: "Smart conversations that convert visitors into leads"
  },
  {
    title: "Analytics Dashboard",
    icon: "/assets/analytics-icon.png",
    description: "Deep insights into customer interactions"
  },
  {
    title: "24/7 Availability",
    icon: "/assets/clock-icon.png",
    description: "Never miss a potential lead"
  }
];

const stats = [
  { label: "Active Users", value: "2,000+" },
  { label: "Leads Generated", value: "50,000+" },
  { label: "Conversion Rate", value: "35%" },
  { label: "Customer Satisfaction", value: "98%" }
];

const RequireAuth = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

function App() {
  const auth = useAuth();
  const [isSubscribed, setIsSubscribed] = useState(false); 
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [shouldLoadLexUi, setShouldLoadLexUi] = useState(false);

  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      if (auth.user?.profile?.email) {
        const result = await checkSubscription(auth.user.profile.email);
        setIsSubscribed(result.subscribed);
        setSubscriptionId(result.subscriptionId);
      }
    };
  
    if (auth.isAuthenticated) {
      fetchSubscriptionStatus();
    }
  }, [auth]);


  useEffect(() => {
    // const isOnLexPage = window.location.href.includes('lexWebUiEmbed=true');
    
    if (auth.isAuthenticated) {
      setShouldLoadLexUi(true);
    }
  }, [auth]);
  
  // useEffect(() => {
  //   const userId = auth.user?.profile?.email || `guest-${Date.now()}`;
  //   const idToken = auth.user?.id_token || auth.user?.token?.id_token || auth.user?.access_token; // adjust if needed
  
  //   const handleLexInitRequest = (event) => {
  //     if (event.data?.event === "initIframeConfig") {
  //       console.log("[Lex] Received initIframeConfig, sending config...");
  
  //       const config = {
  //         region: "us-east-1",
  //         cognito: {
  //           poolId: "us-east-1:ddf16a8a-c766-452f-b3af-17e2b5b62341", // User Pool ID
  //           identityPoolId: "us-east-1:ddf16a8a-c766-452f-b3af-17e2b5b62341", // Identity Pool ID
  //           aws_cognito_region: "us-east-1",
  //           loginMap: {
  //             "cognito-idp.us-east-1.amazonaws.com/us-east-1:ddf16a8a-c766-452f-b3af-17e2b5b62341": auth.user.id_token
  //           }
  //         },
  //         lex: {
  //           botName: "ConversifyBot",
  //           initialText: "👋 Hi! I can help you with product recommendations or checkout help.",
  //           initialSpeechInstruction: "Say your question to get started.",
  //           userId: userId,
  //           defaultUserId: userId,
  //           defaultUserName: "Guest",
  //           region: "us-east-1",
  //           retryOnLexPostTextTimeout: false,
  //           retryCountPostTextTimeout: 1,
  //           v2BotId: "VFGRISYTN3",
  //           v2BotAliasId: "TSTALIASID",
  //           v2BotLocaleId: "en_US",
  //           allowStreamingResponses: false
  //         },
  //         ui: {
  //           parentOrigin: "https://www.getleadamplify.com",
  //           toolbarTitle: "Conversify Assistant",
  //           enableLogin: false,
  //           enableSFX: false,
  //           AllowSuperDangerousHTMLInMessage: true,
  //           messageMenu: true,
  //           enableLogs: true
  //         },
  //         polly: {
  //           voiceId: "Salli"
  //         },
  //         iframe: {
  //           iframeOrigin: "https://www.getleadamplify.com",
  //           iframeSrcPath: "/lex/index.html#/?lexWebUiEmbed=true"
  //         }
  //       };
  
  //       event.source.postMessage({
  //         event: "resolve",
  //         type: "initIframeConfig",
  //         data: config
  //       }, event.origin);
  //     }
  //   };
  
  //   window.addEventListener("message", handleLexInitRequest);
  //   return () => {
  //     window.removeEventListener("message", handleLexInitRequest);
  //   };
  // }, [auth]);
  // useEffect(() => {
  //   const userId = auth.user?.profile?.email || `guest-${Date.now()}`;
  //   const idToken = auth.user?.id_token || auth.user?.access_token;
  
  //   const config = {
  //     region: "us-east-1",
  //     cognito: {
  //       poolId: "us-east-1:ddf16a8a-c766-452f-b3af-17e2b5b62341",
  //       identityPoolId: "us-east-1:ddf16a8a-c766-452f-b3af-17e2b5b62341",
  //       aws_cognito_region: "us-east-1",
  //       loginMap: {
  //         "cognito-idp.us-east-1.amazonaws.com/us-east-1_9DfXf1K75": idToken
  //       }
  //     },
  //     lex: {
  //       botName: "ConversifyBot",
  //       initialText: "👋 Hi! I can help you with product recommendations or checkout help.",
  //       initialSpeechInstruction: "Say your question to get started.",
  //       userId: userId,
  //       defaultUserId: userId,
  //       defaultUserName: "Guest",
  //       region: "us-east-1",
  //       retryOnLexPostTextTimeout: false,
  //       retryCountPostTextTimeout: 1,
  //       v2BotId: "VFGRISYTN3",
  //       v2BotAliasId: "TSTALIASID",
  //       v2BotLocaleId: "en_US",
  //       allowStreamingResponses: false
  //     },
  //     ui: {
  //       parentOrigin: "https://www.getleadamplify.com",
  //       toolbarTitle: "Conversify Assistant",
  //       enableLogin: false,
  //       enableSFX: false,
  //       AllowSuperDangerousHTMLInMessage: true,
  //       messageMenu: true,
  //       enableLogs: true
  //     },
  //     polly: {
  //       voiceId: "Salli"
  //     },
  //     iframe: {
  //       iframeOrigin: "https://www.getleadamplify.com",
  //       iframeSrcPath: "/lex/index.html#/?lexWebUiEmbed=true"
  //     }
  //   };
  
  //   const handleLexInitRequest = (event) => {
  //     const isExpectedEvent = event.data?.event === "initIframeConfig";
  //     const isSameOrigin = event.origin === "https://www.getleadamplify.com";
  
  //     if (isExpectedEvent && isSameOrigin) {
  //       console.log("[Lex] Sending embedded iframe config via postMessage...");
  //       event.source.postMessage(
  //         {
  //           event: "resolve",
  //           type: "initIframeConfig",
  //           data: config
  //         },
  //         event.origin
  //       );
  //     }
  //   };
  
  //   window.addEventListener("message", handleLexInitRequest);
  
  //   return () => {
  //     window.removeEventListener("message", handleLexInitRequest);
  //   };
  // }, [auth]);
  
  useEffect(() => {
    const idToken = auth.user?.id_token || auth.user?.access_token;
    const email = auth.user?.profile?.email;
  
    const handleCredentialsRequest = (event) => {
      if (event.data?.event === 'getCredentials') {
        console.log('[Lex] Responding to getCredentials event');
  
        event.source.postMessage({
          event: 'setCredentials',
          data: {
            token: idToken,
            provider: 'cognito',
            userId: email
          }
        }, event.origin);
      }
    };
  
    if (auth.isAuthenticated && idToken) {
      window.addEventListener('message', handleCredentialsRequest);
    }
  
    return () => {
      window.removeEventListener('message', handleCredentialsRequest);
    };
  }, [auth]);
  
  const signOutRedirect = async () => {
    const clientId = "4btginmodlum1duo8drrhmbacg";
    const logoutUri = "https://www.getleadamplify.com/";
    const cognitoDomain = "https://us-east-19dfxf1k75.auth.us-east-1.amazoncognito.com";

    try {
      await auth.removeUser();
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${logoutUri}`;
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const renderLandingPage = () => (
    <div className="landing-container">
      <div className="hero-section">
        <h1 style={styles.title}>Transform Your Lead Generation</h1>
        <p style={styles.subtitle}>
          Harness the power of AI to convert visitors into valuable leads
        </p>
        <button
          onClick={() => auth.signinRedirect()}
          style={{ ...styles.button, ...styles.primaryButton }}
        >
          Start Free Trial
        </button>
      </div>

      <div className="dashboard-container">
        <div className="stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <h3 style={{ fontSize: '2rem', color: '#4CAF50' }}>{stat.value}</h3>
              <p style={{ color: '#666' }}>{stat.label}</p>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <img src={feature.icon} alt={feature.title} className="feature-icon" />
              <h3 style={{ color: '#2c3e50' }}>{feature.title}</h3>
              <p style={{ color: '#666' }}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderDashboard = () => (
    <div className="dashboard-container">
      <div className="welcome-banner">
        <h2 style={{ fontSize: '2rem', marginBottom: '10px' }}>
          Welcome back, {auth.user?.profile.email}!
        </h2>
        <p>Your lead generation dashboard is ready</p>
      </div>

      {isSubscribed ? (
        <>
         {shouldLoadLexUi && (
            <iframe
              title="ConversifyBot"
              src="https://www.getleadamplify.com/lex/index.html#/?lexWebUiEmbed=true"
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                width: '500px',
                height: '600px',
                border: 'none',
                zIndex: 1000,
                borderRadius: '12px',
                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.2)'
              }}
              allow="microphone"
            />
          )}

          <div className="buttons-container">
            <button
              onClick={() => (window.location.href = "/admin")}
              style={{ ...styles.button, ...styles.secondaryButton }}
            >
              <span style={{ marginRight: '8px' }}>📊</span> Admin Panel
            </button>
            <button
              onClick={signOutRedirect}
              style={{ ...styles.button, ...styles.dangerButton }}
            >
              <span style={{ marginRight: '8px' }}>👋</span> Sign out
            </button>
          </div>
        </>
      ) : (
        <div className="feature-card upgrade-card">
          <h3 style={{ color: '#f44336' }}>Upgrade Your Account</h3>
          <p style={{ margin: '20px 0' }}>
            Unlock premium features and start generating more leads today
          </p>
          <div className="buttons-container">
            <button
              onClick={() => (window.location.href = "/admin")}
              style={{ ...styles.button, ...styles.primaryButton }}
            >
              <span style={{ marginRight: '8px' }}>⭐</span> Subscribe Now
            </button>
            <button
              onClick={signOutRedirect}
              style={{ ...styles.button, ...styles.dangerButton }}
            >
              <span style={{ marginRight: '8px' }}>👋</span> Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={auth.isAuthenticated ? renderDashboard() : renderLandingPage()}
        />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <AdminPage 
                isSubscribed={isSubscribed}
                subscriptionId={subscriptionId}
              />
            </RequireAuth>
          }
        />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/cancel" element={<CancelPage />} />
      </Routes>
    </Router>
  );
}

export default App;
